export const BASE_URL = 'https://api-maps.yandex.ru';

export const API_KEY = window.YMAPS_API_KEY;

export const DEFAULT_EASING_DURATION = 500;

export const DEFAULT_CLUSTER_BY_GRID_SIZE = 128;

// test-ids

export const MAP_CONTAINER_TEST_ID = 'map-container';
